import { render, staticRenderFns } from "./_FooterMobile.vue?vue&type=template&id=60b6c90f&"
import script from "./_FooterMobile.vue?vue&type=script&lang=js&"
export * from "./_FooterMobile.vue?vue&type=script&lang=js&"
import style0 from "./_FooterMobile.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QFooter,QBtn});
